/**
 * Copyright 2021 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
'use memo';
import { getCartridgeType } from '@/utils/getCartridgeType';
import type { ShelfPageBodyComplete, ShelfPageBodyItemResultsList } from '@/types/legacy';
import { isShelfPageBodyItemResultsList } from '../utils/isShelfPageBodyItemResultsList';

export const useGetShelfPageRecords = (
  shelfPageBody: ShelfPageBodyComplete | undefined,
): ShelfPageBodyItemResultsList | undefined => {
  const shelfPageRecords = (shelfPageBody?.filter(
    (contentItem) => getCartridgeType(contentItem['@type']) === 'ResultsList',
  ) ?? [])[0];

  if (!isShelfPageBodyItemResultsList(shelfPageRecords)) {
    return undefined;
  }

  return shelfPageRecords;
};
